import {
	TaskTemplate,
	taskTemplateListSchema,
	TaskTemplatesApiResponse,
	taskTemplateSchema,
} from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

// API functions
export const getTaskTemplate = async (slug: string): Promise<TaskTemplate> => {
	const { body } = await clientRequest.get(`/api/task-templates/${slug}`, {
		schema: taskTemplateSchema,
	});
	return body;
};

export const getTaskTemplates = async (query?: string): Promise<TaskTemplatesApiResponse> => {
	const { body } = await clientRequest.get(`/api/task-templates${query ? `?${query}` : ''}`, {
		schema: taskTemplateListSchema,
	});
	return body;
};
